<template>
  <div class="main-banner">
    <div class="banner-title">
      소상공인과 함께하는<br> <strong>2026 동행축제</strong>
      <div class="sub">
        <span class="txt">로컬에서도 즐기는 모두의 동행축제</span>
        <span class="date">2026. 4. 11 ~ 5. 10</span>
        <a 
          href="javascript:void(0)" 
          @click="onClickEngInfo"
          class="btnEng"
        >
          English &gt;
        </a>
      </div>
    </div>
    <div class="banner-wrapper">
      <div class="lt">
        <div
          v-if="banners && banners.length > 0"
          ref="bannerSwiper"
          :class="['swiper', 'banner-component', banners ? `banner-count-${banners.length}` : '']"
        >
        <!-- 슬라이드 내용 -->
        <div class="swiper-wrapper">
          <div v-for="(item, idx) in banners" :key="idx" class="swiper-slide"> 
            <component
              :is="isInternalRoute(item.mvmnptUrl,item.urlType) ? 'router-link' : 'a'"
              :to="isInternalRoute(item.mvmnptUrl,item.urlType) ? getInternalPath(item.mvmnptUrl) : undefined"
              :href="!isInternalRoute(item.mvmnptUrl,item.urlType) && !isPlaceholderExternal(item.mvmnptUrl, item.urlType) ? getExternalUrl(item.mvmnptUrl) : undefined"
              :class="['banner-slide-link', { 'external-link': !isInternalRoute(item.mvmnptUrl,item.urlType) && !isPlaceholderExternal(item.mvmnptUrl, item.urlType) }]"
              :title="isInternalRoute(item.mvmnptUrl,item.urlType) || isPlaceholderExternal(item.mvmnptUrl, item.urlType) ? undefined : '새창으로 바로가기'"
              :target="isInternalRoute(item.mvmnptUrl,item.urlType) || isPlaceholderExternal(item.mvmnptUrl, item.urlType) ? undefined : '_blank'">
              <div class="banner-slide-content">
                <div class="banner-image">
                  <img
                    :src="getSafeImageUrl(item.imgPtUrl)"
                    :alt="item.bannrTit || 'Banner'"
                  />
                </div>
              </div>
            </component>
            <!-- 링크가 없는 경우를 위한 대체 div -->
            <div v-if="!item.mvmnptUrl" class="banner-slide-content">
              <div class="banner-image">
                <img
                  :src="getSafeImageUrl(item.imgPtUrl)"
                  :alt="item.bannrTit || 'Banner'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <in-ready v-else />
      <div class="navi-wrap">
        <div class="swiper-pagination"></div>
        <!-- 컨트롤 버튼 (배너가 있을 때만 표시) -->
        <div v-if="banners && banners.length > 0" class="swiper-controls">
              <button
              type="button"
              class="swiper-button-prev"
              :disabled="!isSwiperReady"
              @click="goToPrevSlide"
              >
              이전
            </button>
            <button type="button" :disabled="!isSwiperReady"
            @click="togglePlay" :class="['swiper-button-play-control', playing ? 'is-playing' : 'is-paused']">{{ playing ? '정지' : '재생' }}</button>
            <button
            type="button"
            class="swiper-button-next"
            :disabled="!isSwiperReady"
            @click="goToNextSlide"
            >
            다음
          </button>
        </div>
      </div>
    </div>
      
      <div class="rt">
        <a href="/ko/festival" class="img-banner">
          <img src="../assets/img/main/festival_banner.jpg" alt="">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ACT_GET_BANNER_LIST } from "../store/_act_consts";
import { getCheckItems } from "../assets/js/utils";
import { MUT_SET_BANNERS, MUT_SET_LAST_BANNER_INDEX, MUT_SHOW_ALERT } from "../store/_mut_consts";
import InReady from '@/components/common/InReady';
import Swiper from "swiper";

export default {
  name: "Banner",
  components: { InReady },
  data: () => ({
    resizeTimer: null,
    swiperInstance: null,
    activeSlideIndex: 0,
    playing: true,
    isSwiperReady: false,
    swiperOptions: {
      slidesPerView: 1,
      /* centeredSlides: true, */
      /* spaceBetween: 20, */
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".lt .swiper-pagination",
        dynamicBullets: true,

      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          /* spaceBetween: 0, */
        },
        901: {
          slidesPerView: 1,
          /* spaceBetween: 12, */
          loopAdditionalSlides: 1,
        },
        1161: {
          slidesPerView: 1,
        }
      },
    },
  }),
  computed: {
    ...mapGetters("main", ["banners", "bannerExpired", "lastBannerIndex"]),
    isMobile() {
      return window.innerWidth <= 800;
    },
    paginationType() {
      return this.isMobile ? 'bullets' : 'fraction';
    }
  },
  watch: {
    banners(newBanners) {
      if (newBanners && newBanners.length > 0) {
        this.$nextTick(() => {
          if (this.swiperInstance && !this.swiperInstance.destroyed) {
            this.swiperInstance.update();
          } else {
            this.initializeSwiper();
          }
        });
      } else if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
        this.isSwiperReady = false;
      }
    },
  },
  async created() {
    if (
      !this.banners ||
      this.banners.length === 0 ||
      new Date().getDate() > this.bannerExpired
    ) {
   
      try {
        const res = await this.getBannerList();
        const bannerItems = getCheckItems(res);
        if (Array.isArray(bannerItems)) {
          await this.$store.commit(`main/${MUT_SET_BANNERS}`, bannerItems);
        } else {
          console.error("[Banner] Invalid banner items received:", res);
          await this.$store.commit(`main/${MUT_SET_BANNERS}`, []);
        }
      } catch (error) {
        console.error("[Banner] Error fetching banner list in created hook:", error);
        await this.$store.commit(`main/${MUT_SET_BANNERS}`, []);
      }
    } else {
        console.log("[Banner] Using existing banner data from store.");
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeSwiper();
    });
    
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    if (this.swiperInstance && !this.swiperInstance.destroyed) {
      try {
        const currentIndex = this.swiperInstance.realIndex !== undefined
                             ? this.swiperInstance.realIndex
                             : this.swiperInstance.activeIndex;
        if (currentIndex >= 0) {
          // --- 뮤테이션 호출 수정: $store.commit 사용 ---
          this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, currentIndex);
     
        }
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
        this.isSwiperReady = false;
  
      } catch (error) {
          console.error("[Banner] Error during beforeDestroy:", error);
      }
    }
    window.removeEventListener('resize', this.handleResize);

    if (this.swiperInstance && !this.swiperInstance.destroyed) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  },
  methods: {
    // mapMutations 제거 (직접 commit 사용)
    // ...mapMutations("main", [MUT_SET_BANNERS, MUT_SET_LAST_BANNER_INDEX]),

    getBannerList() {
      return this.$store.dispatch(`main/${ACT_GET_BANNER_LIST}`);
    },
    onClickEngInfo(e) {
      if (e) e.preventDefault();
      const targetDate = new Date("2026-04-11 00:00:00");
      const nowDate = new Date();
      if (nowDate < targetDate) {
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: "준비 중입니다.",
          rightNow: true,
        });
      } else {
        this.$router.push("/en");
      }
    },
    async initializeSwiper() {

      const swiperParams = JSON.parse(JSON.stringify(this.swiperOptions));
      const isMobile = window.innerWidth <= 800;

      swiperParams.pagination = {
        el: ".lt .swiper-pagination",
        clickable: true,
        type: isMobile ? "bullets" : "fraction",
        dynamicBullets: false,
      };

      if (
        !this.banners ||
        this.banners.length === 0 ||
        !this.$refs.bannerSwiper ||
        this.swiperInstance
      ) {
        return;
      }


      let newInstance = null;

      // 배너 개수에 맞춰 옵션 조정
      const bannerCount = this.banners.length;

      // 슬라이드가 부족할 때 스와이프 기능 비활성화 (PC 등에서 딱 맞게 떨어질 때)
      swiperParams.watchOverflow = true;

      if (bannerCount > 0) {
        if (swiperParams.slidesPerView > bannerCount) {
          swiperParams.slidesPerView = bannerCount;
        }
        if (swiperParams.breakpoints) {
          Object.keys(swiperParams.breakpoints).forEach(bp => {
            if (swiperParams.breakpoints[bp].slidesPerView > bannerCount) {
              swiperParams.breakpoints[bp].slidesPerView = bannerCount;
            }
          });
        }

        // 배너가 1개일 때만 루프와 자동재생을 끕니다.
        if (bannerCount === 1) {
          swiperParams.loop = false;
          swiperParams.autoplay = false;
        }
      }

      try {
        if (!(this.$refs.bannerSwiper instanceof HTMLElement)) {
          throw new Error("bannerSwiper ref is not a valid HTMLElement");
        }

        newInstance = new Swiper(this.$refs.bannerSwiper, {
          ...swiperParams,
          on: {
            slideChange: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                const currentIndex = this.swiperInstance.realIndex !== undefined
                                     ? this.swiperInstance.realIndex
                                     : this.swiperInstance.activeIndex;
                this.activeSlideIndex = currentIndex;
              }
            },
            click: (e) => {
              // Swiper 5.x passes only the click event to this handler
              // Use the created instance reference to access clickedSlide/Index
              this.onSwiperClick(this.swiperInstance || newInstance, e);
            },
            init: () => {
              console.log("[Banner] Swiper init callback executed.");
            },
            autoplayStop: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                console.log("[Banner] Autoplay stopped");
              }
            },
            autoplayStart: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                console.log("[Banner] Autoplay started");
              }
            },
            slideChangeTransitionEnd: () => {
              if (this.swiperInstance && !this.swiperInstance.destroyed) {
                const currentRealIndex = this.swiperInstance.realIndex !== undefined
                                         ? this.swiperInstance.realIndex
                                         : this.swiperInstance.activeIndex;
                this.activeSlideIndex = currentRealIndex;
                // --- 슬라이드 변경 시에도 인덱스 저장 ---
                if (currentRealIndex >= 0) {
                    this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, currentRealIndex);
                  
                }
              }
            },
          },
        });

        if (!newInstance || newInstance.destroyed) {
          throw new Error("Failed to create a valid Swiper instance");
        }

        this.swiperInstance = newInstance;
     

        await this.$nextTick();

        if (this.swiperInstance && !this.swiperInstance.destroyed) {
     
            this.isSwiperReady = true;

            // --- 로깅 추가: 스토어에서 읽어온 값 확인 ---
 
            const targetIndex = this.lastBannerIndex;
            let shouldStartAutoplay = this.playing;

            const initialIndex = this.swiperInstance.realIndex !== undefined ? this.swiperInstance.realIndex : this.swiperInstance.activeIndex;

            // --- 로깅 추가: 복원 조건 확인 ---
         
            if (targetIndex >= 0 && targetIndex < this.banners.length && targetIndex !== initialIndex) {
          
                try {
                    if (this.swiperOptions.loop) {
                        if (typeof this.swiperInstance.slideToLoop === 'function') {
                            this.swiperInstance.slideToLoop(targetIndex, 0, false);
                        } else { console.error("[Banner] slideToLoop not found"); }
                    } else {
                        if (typeof this.swiperInstance.slideTo === 'function') {
                            this.swiperInstance.slideTo(targetIndex, 0, false);
                        } else { console.error("[Banner] slideTo not found"); }
                    }
                    this.activeSlideIndex = targetIndex;
             
                } catch (slideError) {
                    console.error(`[Banner] Error during slideTo/Loop AFTER nextTick:`, slideError);
                    this.activeSlideIndex = initialIndex;
                }
            } else {
             
                this.activeSlideIndex = initialIndex;
            }

            if (shouldStartAutoplay && this.swiperInstance.autoplay) {
               if (!this.swiperInstance.autoplay.running) {
                   this.swiperInstance.autoplay.start();
                
               } else {
                   console.log("[Banner] Autoplay already running AFTER nextTick.");
               }
            } else if (shouldStartAutoplay) {
                console.warn("[Banner] Autoplay could not be started AFTER nextTick.");
            }
        } else {
             console.error("[Banner] Swiper instance became invalid before operations in nextTick.");
             this.isSwiperReady = false;
        }

      } catch (error) {
        console.error("[Banner] Failed to initialize Swiper:", error);
        this.isSwiperReady = false;
        if (this.swiperInstance) {
          try { this.swiperInstance.destroy(true, true); } catch (e) {}
          this.swiperInstance = null;
        } else if (newInstance) {
           try { newInstance.destroy(true, true); } catch (e) {}
        }
      }
    },
    onSwiperClick(swiper, event) {
      try {
        if (!swiper) return;
        const slideEl = swiper.clickedSlide || (event && event.target && event.target.closest ? event.target.closest('.swiper-slide') : null);
        if (!slideEl) return;
        // 루프 모드에서는 data-swiper-slide-index로 원본 인덱스를 확인
        let realIdx = undefined;
        if (slideEl.getAttribute) {
          const attr = slideEl.getAttribute('data-swiper-slide-index');
          if (attr != null) {
            const parsed = parseInt(attr, 10);
            if (!isNaN(parsed)) realIdx = parsed;
          }
        }
        if (realIdx == null) {
          const ci = typeof swiper.clickedIndex === 'number' ? swiper.clickedIndex : -1;
          realIdx = (ci >= 0 && this.banners && this.banners.length > 0)
            ? (ci % this.banners.length)
            : this.activeSlideIndex;
        }
        if (realIdx == null || realIdx < 0 || !this.banners || !this.banners[realIdx]) return;
        const item = this.banners[realIdx];

        const url = item && item.mvmnptUrl;
        const isInternal = this.isInternalRoute(url, item && item.urlType);
        const isPlaceholder = this.isPlaceholderExternal(url, item && item.urlType);

        // 인덱스 저장
        if (typeof realIdx === 'number' && realIdx >= 0) {
          this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, realIdx);
        }

        // 분기 처리: 이벤트 기본 동작 제어는 케이스별로 다르게
        if (isPlaceholder) {
          if (event && typeof event.preventDefault === 'function') event.preventDefault();
          if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
          this.$store.commit(`common/${MUT_SHOW_ALERT}`, { title: '4/11(토)부터 구매 가능합니다.', rightNow: true });
          return;
        }

        if (isInternal) {
          // router-link가 이미 네비게이션을 처리하므로 여기서 중복 호출하지 않음
          return;
        }

        // 외부 정상 URL: 앵커 기본 동작( target="_blank" )에 맡기되, 앵커가 없으면 window.open
        const anchor = event && event.target && event.target.closest ? event.target.closest('a') : null;
        if (anchor) {
          // 기본 동작으로 새 탭 오픈. 여기서는 preventDefault 호출하지 않음.
          return;
        } else {
          // 앵커가 없을 때만 수동 오픈
          if (event && typeof event.preventDefault === 'function') event.preventDefault();
          if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
          window.open(this.getExternalUrl(url), '_blank');
          return;
        }
      } catch (e) {
        console.error('[Banner] onSwiperClick error:', e);
      }
    },
    handleItemNavigation(item, storeIndex, fallbackIndex) {
      if (!item) return;
      const url = item.mvmnptUrl;
      const isInternal = this.isInternalRoute(url, item.urlType);
      const indexToStore = (typeof storeIndex === 'number' && storeIndex >= 0) ? storeIndex : fallbackIndex;
      if (typeof indexToStore === 'number' && indexToStore >= 0) {
        this.$store.commit(`main/${MUT_SET_LAST_BANNER_INDEX}`, indexToStore);
      }
      // 외부 링크이고 URL이 'https://'인 경우, 팝업만
      if (!isInternal && url === 'https://') {
        this.$store.commit(`common/${MUT_SHOW_ALERT}`, {
          title: '준비 중입니다.',
          rightNow: true,
        });
        return;
      }
      if (isInternal) {
        const path = this.getInternalPath(url);
        this.$router.push(path);
      } else {
        window.open(this.getExternalUrl(url), '_blank');
      }
    },
    togglePlay() {
      if (!this.swiperInstance || this.swiperInstance.destroyed || !this.swiperInstance.autoplay) {
        console.error(
          "[Banner] Swiper instance or autoplay module is not available or destroyed."
        );
        return;
      }
      this.playing = !this.playing;
      if (this.playing) {
        this.swiperInstance.autoplay.start();
      
      } else {
        this.swiperInstance.autoplay.stop();
     
      }
    },
    goToPrevSlide() {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.slidePrev();
      }
    },
    goToNextSlide() {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        this.swiperInstance.slideNext();
      }
    },
    goToSlide(index) {
      if (this.swiperInstance && !this.swiperInstance.destroyed) {
        if (this.swiperOptions.loop) {
          this.swiperInstance.slideToLoop(index);
        } else {
          this.swiperInstance.slideTo(index);
        }
      }
    },
    getSafeImageUrl(url) {
      try {
        return url && url.startsWith("http") ? url : "/assets/default-banner.png";
      } catch (e) {
        console.error(`[Banner] Failed to load default image:`, e);
        return '';
      }
    },
    isInternalRoute(url, type) {
      if (!url) return false;
      // urlType이 1이면 내부 링크로 간주합니다.
      return type == 1 || type == '1';
    },
    getInternalPath(url) {
      if (!url) return undefined;
      try {
        const parsedUrl = new URL(url, window.location.origin);
        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      } catch (e) {
        return url.startsWith('/') ? url : `/${url}`;
      }
    },
    getExternalUrl(url) {
      if (!url) return '#';
      if (/^(https?:\/\/|\/\/)/i.test(url)) {
        return url;
      }
      if (!url.startsWith('/') && url.includes('.')) {
        return `//${url}`;
      }
      return url;
    },
    isPlaceholderExternal(url, type) {
      if (this.isInternalRoute(url, type)) return false;
      if (!url) return true;
      const s = String(url).trim();
      return s === 'https://';
    },
    handleResize() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        if (!this.swiperInstance) return;

        const isMobile = window.innerWidth <= 800;
        const currentType = this.swiperInstance.params.pagination.type;
        const newType = isMobile ? 'bullets' : 'fraction';

        // 👉 타입이 같으면 아무것도 안함
        if (currentType === newType) return;

        // 👉 기존 swiper 완전 제거
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
        this.isSwiperReady = false;

        // 👉 다시 생성 (여기서 pagination도 다시 설정됨)
        this.$nextTick(() => {
          this.initializeSwiper();
        });

      }, 200); // resize debounce
    }
  },
};
</script>

<style scoped>
.m-block {display:none;}
.pc-block {display:block;}
@font-face {
	font-family: 'Gmarket Sans';
	font-weight: 700;
	font-display: swap;
	src: url('../assets/fonts/woff2/GmarketSansBold.woff2') format('woff2'), url('../assets/fonts/woff/GmarketSansBold.woff') format('woff');
}

@font-face {
	font-family: 'Gmarket Sans';
	font-weight: 400;
	font-display: swap;
	src: url('../assets/fonts/woff2/GmarketSansMedium.woff2') format('woff2'), url('../assets/fonts/woff/GmarketSansMedium.woff') format('woff');
}
.main-banner {
  position: relative;
  margin:-100px auto 0;
  padding:100px 0 68px;
  width: 100%;
  background:url("../assets/img/main/img-main-bg.png") no-repeat center/cover;
}
.main-banner .banner-title {
  margin: 50px auto 46px;
  padding:0 24px;
  width:100%;
  max-width:1648px;
  font-family: 'Gmarket Sans';
  text-indent:10px;
  letter-spacing: -0.02em;
  line-height: 1.2;
  font-size: 60px;
  color: #333;
  font-weight:300;
}
.main-banner .banner-title strong {
  font-size:84px;
  /* color: #006F45; */
  font-weight: 700;
  background: -webkit-linear-gradient(0deg, #1A7348 0%, #0D72AC 70.5%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.main-banner .banner-title .sub {
  display:flex;
  align-items:center;
  gap:16px;
  letter-spacing:0;
}
.main-banner .banner-title .sub span {
  font-family:var(--font-family-base);
  font-size:20px;
  color:#555;
  font-weight:600;
}
.main-banner .banner-title .sub .date {
  padding:8px 24px;
  border-radius:40px;
  font-size:18px;
  color:#fff;
  font-weight:700;
  background:#0D72AC;
}
.main-banner .banner-title .btnEng {
  display:inline-block;
  position:relative;
  margin-left:auto;
  padding:8px 24px;
  border-radius:40px;
  font-size:18px;
  color:#fff;
  font-weight:700;
  text-decoration: none;
  background:#40B7EE;
}
.banner-wrapper {
  display:flex;
  gap:40px;
  position: relative;
  max-width: 1648px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
}
.banner-wrapper .lt {
  display:block;
  position:relative;
  border-radius:32px;
  flex:1;
  width:calc(50% - 20px);
}
.banner-wrapper .rt {
  overflow:hidden;
  flex:1;
  width:calc(50% - 20px);
  aspect-ratio: 780/460;
  border-radius:32px;
}
.banner-wrapper .rt .img-banner {
  display:block;
  position: relative;
  height: 100%;
}
.banner-wrapper .rt .img-banner img {
  position:absolute;
  left:50%;
  top:50%;
  width:100%; 
  height:100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}
.banner-component {
  flex:1;
  margin:0;
  overflow: hidden;
  width: 100%;
  border-radius:32px;
  aspect-ratio: 780/460;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
 /*  aspect-ratio: 1328 / 411; */ /* 1개 노출 시에 맞게 비율 조정 */
}

.banner-slide-content {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.banner-slide-link {
  width: 100%; /* 2025-08-04  */
  height: 100%;
}
.banner-image{
  height:100%;
}
.banner-image img {
  display: block;
  position:absolute;
  left:50%;
  top:50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.navi-wrap {
    display: flex;
    position: absolute;
    left: 0;
    bottom: 0;
    gap: 16px;
    background: #fff;
    width: 200px;
    justify-content: center;
    border-radius: 0 24px 0 32px;
    z-index: 1;
}
/* 버튼 위치 조정 - 우측으로 배치 */
.swiper-controls {
  display: flex;
  height:50px;
  z-index: 20;
  /* transform: translate(-50%, -50%); */
}
.swiper-button-prev {
  left:96px;
  background:url("../assets/img/main/btn-swiper-prev-02.svg") no-repeat center;
}
.swiper-button-next {
  right:32px;
  background:url("../assets/img/main/btn-swiper-next-02.svg") no-repeat center;
}
.swiper-button-play-control {
  position: absolute;
  right:56px;
  background:url("../assets/img/main/btn-swiper-play-control-02.svg") no-repeat center;
}
.swiper-button-play-control.is-paused {
  background:url("../assets/img/main/btn-swiper-play-on-control-02.svg") no-repeat center;
}
.swiper-button-prev,
.swiper-button-next,
.swiper-button-play-control {
  position: initial;
  pointer-events: auto;
  margin-top:0;
  width: 24px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent:-9999px;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* pagination + pause 버튼 나란히 정렬 */
.pagination-control-group {
  margin: 20px -158px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.swiper-pagination {
  display:flex;
  position: initial;
  align-items: center;
  gap:6px;
  height: 50px;
  font-size:18px;
  color:#1d1d1d;
}

.swiper-pagination-fraction.swiper-pagination {
  width:auto !important;
}

.swiper-pagination-bullet {
  min-width:12px !important;
  height:12px!important;
  background:red;
}
/* 재생/정지 버튼 */
.btn-pause {
  position:absolute;
  right:-118px;
  bottom:0;
  z-index: 21;
  width: 40px;
  height: 40px;
  border-top: 1px solid #C6C6C6;
  border-bottom: 1px solid #C6C6C6;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* 배너 개수가 1개 또는 2개일 때 가운데 정렬 및 화살표 숨김 (PC 기준) */
@media (min-width: 1161px) {
  .banner-count-1 .swiper-wrapper {
    justify-content: center !important;
  }
  .banner-count-1 + .swiper-controls .swiper-button-prev,
  .banner-count-1 + .swiper-controls .swiper-button-next {
    display: none !important;
  }
}

/* 버튼 비활성화 스타일 */
.swiper-button-prev:disabled,
.swiper-button-next:disabled,
.btn-pause:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 반응형 대응 */
/* 태블릿 */
@media(max-width:1024px){
  .banner-wrapper {
    gap:30px;
  }
  .main-banner .banner-title {
    font-size:40px;
  }
  .main-banner .banner-title strong {
    font-size:68px;
  }
  .main-banner .banner-title .sub span {
    font-size:18px;
  }
  .main-banner .banner-title .sub .date {
    font-size:16px;
  }
  .navi-wrap {
    width:170px;
  }
  .banner-wrapper .swiper-pagination {
    height:38px;
  }
  .banner-wrapper .swiper-controls {
    height:38px;
  }
  .banner-wrapper .swiper-button-prev,
  .banner-wrapper .swiper-button-next,
  .banner-wrapper .swiper-button-play-control {
    height:38px;
  }
}

/* 모바일 */
@media (max-width: 800px) {
  .m-block {display:block;}
  .pc-block {display:none;}
  .main-banner {
    margin-top:-60px;
    padding:60px 0 40px;
  }
  .banner-wrapper {
    flex-direction: column;
    gap:20px;
    padding:0 16px;
  }
  .main-banner .banner-title {
    margin:16px 0 22px;
    text-align: center;
    font-size:22px;
    font-weight:400;
  }
  .main-banner .banner-title strong {
    display:inline-block;
    padding-top:10px;
    line-height:1;
    font-size:50px;
  }
  .main-banner .banner-title .sub  {
    flex-direction: column;
    gap:10px;
  }
  .main-banner .banner-title .sub .txt {
    margin-top:10px;
    font-size: 17px;
  }
  .main-banner .banner-title .sub .date {
    padding:5px 16px;
    font-size: 15px;
  }
  .main-banner .banner-title .btnEng {
    position:fixed !important;
    top:14px; 
    right:16px;
    padding:6px 12px 6px 6px;
    font-size:13px;
    z-index: 501;
  }
  .navi-wrap {
    position: initial;
    margin-top:6px;
    width:100%;
    background:transparent;
  }
  .banner-wrapper .swiper-pagination {
    position: relative;
    /* width:84px !important; */
    height:24px;
    gap:0 10px;
  }
  .banner-wrapper .pagination-control-group {
    gap:4px;
    justify-content:center;
    margin-top:8px;
  }
  .banner-wrapper .swiper-button-prev, .swiper-button-next {
    display:none;
  }
  .banner-wrapper .swiper-button-play-control {
    background-image: url("../assets/img/main/btn-swiper-play-control-02-m.svg");
  }
  .banner-wrapper .swiper-button-play-control.is-paused {
    background-image: url("../assets/img/main/btn-swiper-play-on-control-02-m.svg");
  }
  .banner-wrapper .swiper-controls {
    height:24px;
  }
  .banner-wrapper .swiper-button-prev,
  .banner-wrapper .swiper-button-next,
  .banner-wrapper .swiper-button-play-control {
    height:24px;
  }
  .btn-pause {
    position:initial;
    border:none;
    width:36px;
    height:36px;
  }
  .banner-wrapper .lt {
    border-radius:16px;
    width:100%;
  }
  .banner-wrapper .rt {
    border-radius:16px;
    width:100%;
  }
}
</style>
<style>
.banner-wrapper .swiper-pagination-current {
  color:#006F45;
  font-weight:700;
}
/* .swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next,
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next,
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform:scale(1);
} */
/* @media(max-width:800px) {
    .main-banner .swiper-pagination-bullet {
      left:initial!important;
    }
} */
</style>